import { getString } from "../../common/common";

export const EDIT_YOUR_PROFILE = 'Edit_Your_Profile';
export const DELETE_YOUR_PROFILE = 'Delete_Your_Profile';
export const LOG_OUT = 'Logout';
export const MANAGE_BUS_BOOKING = "Manage_Bus_Booking";
export const ACCOUNT_DELETE_CONFIRMATION = 'Are_you_sure_you_want_to_delete_your_account_?';
export const ACCOUNT_DELETED = 'Account_Deleted';
export const DELETED_CONFITMATION = 'Your_account_has_been_deleted_successfully';
export const DELETE_FAILURE = 'Delete_Account_Failed';
export const ACCOUNT_DELETE_ERROR = 'Something_went_wrong_while_deleting_account';


export const translations = {
    en: {

        [EDIT_YOUR_PROFILE]: "Edit Your Profile",
        [DELETE_YOUR_PROFILE]: "Delete Your Profile",
        [LOG_OUT]: "Logout",
        [MANAGE_BUS_BOOKING]: "Manage Bus Booking",
        [ACCOUNT_DELETE_CONFIRMATION]: "Are you sure you want to delete your account ?",
        [ACCOUNT_DELETED]: "Account Deleted",
        [DELETED_CONFITMATION]: 'Your account has been deleted successfully',
        [DELETE_FAILURE]: 'Delete Account Failed',
        [ACCOUNT_DELETE_ERROR]: 'Something went wrong while deleting account',
    },
    kn: {
        [EDIT_YOUR_PROFILE]: "ನಿಮ್ಮ ಪ್ರೊಫೈಲ್ ಎಡಿಟ್ ಮಾಡಿ",
        [DELETE_YOUR_PROFILE]: "ನಿಮ್ಮ ಪ್ರೊಫೈಲ್ ಡಿಲೀಟ್ ಮಾಡಿ",
        [LOG_OUT]: "ಹೊರ ಹೋಗು",
        [MANAGE_BUS_BOOKING]: "ಬಸ್ ಬುಕಿಂಗ್ ನಿರ್ವಹಿಸಿ",
        [ACCOUNT_DELETE_CONFIRMATION]: "ನಿಮ್ಮ ಅಕೌಂಟ್ ಡಿಲೀಟ್ ಮಾಡಲು ನೀವು ಖಚಿತವಾಗಿ ಬಯಸುವಿರಾ?",
        [ACCOUNT_DELETED]: "ಅಕೌಂಟ್ ಡಿಲೀಟ್ ಮಾಡಲಾಗಿದೆ",
        [DELETED_CONFITMATION]: 'ನಿಮ್ಮ ಅಕೌಂಟ್ ಯಶಸ್ವಿಯಾಗಿ ಡಿಲೀಟ್ ಮಾಡಲಾಗಿದೆ',
        [DELETE_FAILURE]: 'ಅಕೌಂಟ್ ಡಿಲೀಟ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ',
        [ACCOUNT_DELETE_ERROR]: 'ಅಕೌಂಟ್ ಡಿಲೀಟ್ ಮಾಡುವಾಗ ಏನೋ ತಪ್ಪಾಗಿದೆ',
    },
};

export const t = (key = "") => {
    return getString(key, translations)
}